<template>
  <div class="input-container">
    <MaskedInput
      v-bind="this.$attrs"
      v-model="data"
      mask="11:11"
      :disabled="disabled"
      placeholder="HH:mm"
      class="input"
      :class="{ 'input--error': !!errorText }"
    />
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import moment from 'moment'
import MaskedInput from 'vue-masked-input'
import VInput from 'vuetify/lib/components/VInput/VInput.js'

export default {
  extends: VInput,
  components: {
    MaskedInput,
  },
  props: {
    disabled: Boolean,
    date: String,
    selectedDate: String,
  },
  data: () => ({
    data: '',
    menu: false,
    errorText: '',
    isRule: false,
  }),

  methods: {
    validate(force, val) {
      // overide validate VInput
      if (force) {
        this.updated(this.data)
      }
      return !this.errorText
    },
    setIsRule(status) {
      this.isRule = status
    },
    updated(value) {
      if (value === '__:__') value = ''
      if (this.rules && this.rules.length && this.isRule) {
        let errorText = ''
        for (const rule of this.rules) {
          errorText = rule(value)
          if (errorText !== true) break
        }
        if (errorText !== true) this.errorText = errorText
        else this.errorText = null
      }
      if (value) {
        if (!this.errorText) {
          const formattedDate = moment(this.selectedDate, 'DD/MM/YYYY')
          const date = moment(this.data, 'HH:mm')
            .date(formattedDate.date())
            .month(formattedDate.month())
            .year(formattedDate.year())
            .toISOString()
          this.$emit('update:date', date)
        }
      } else {
        this.$emit('update:date', '')
      }
      this.menu = false
    },
    reset() {
      if (this.date) {
        this.data = moment(this.date).format('HH:mm')
      } else {
        this.data = ''
      }
    },
  },
  created() {
    this.reset()
  },
  watch: {
    isRule() {
      if (!this.isRule) {
        this.errorText = ''
      }
    },
    data(value) {
      if (value.length === 5) {
        this.isRule = true
        this.updated(this.data)
      }
    },
    date(value) {
      if (value) {
        const time = moment(value).format('HH:mm')
        if (time !== this.data) this.data = moment(value).format('HH:mm')
        this.updated(moment(value).format('HH:mm'))
      } else {
        this.data = ''
        this.updated('')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;
}
.input {
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 4px;
  outline: none;
  padding: 7px 8px;
  box-sizing: border-box;
}

.input:focus {
  border: 2px solid #0d47a1;
  padding: 6px 7px;
}

.input--error {
  border: 2px solid #b71c1c !important;
  padding: 6px 7px;
}
.error-text {
  margin-top: 4px;
  min-height: 14px;
  line-height: 14px;
  position: absolute;
  white-space: nowrap;
}
</style>
